// 导入router
import VueRouter from "vue-router"
// 将组件引入
import index from '../page/index.vue'
import searchPage from '../page/searchPage.vue'
import infoPage from '../page/infoPage.vue'
import aicaigouSearch from '../page/aicaigouSearch.vue'
//创建router实例

 let routes = [
    // 百度竞价查询
    {
        path:'/',
        name: 'index',
        component: index,
        redirect:'searchPage',//默认路由，重定向到searchPage组件
        children:[
            {
                path: '/searchPage',
                name: 'searchPage',
                component: searchPage
            },
            {
                path: '/infoPage',
                name: 'infoPage',
                component: infoPage
            },
        ]
    },
    // 爱采购查询
    {
        path:'/aicaigouSearch',
        name: 'aicaigouSearch',
        component: aicaigouSearch,
    },
  ]
  export default new VueRouter({
    linkActiveClass:'active',
    routes
  })
